import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Shield, Landmark, ClipboardCheck, Siren } from "lucide-react";

const ICONS = [Shield, Landmark, ClipboardCheck, Siren];
const ACCENTS = [
  "from-blue-100 to-blue-50 text-blue-900",
  "from-amber-100 to-amber-50 text-amber-700",
  "from-emerald-100 to-emerald-50 text-emerald-700",
  "from-red-100 to-red-50 text-red-700",
];

const Exams = () => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="exams-section"
      className="relative py-20 sm:py-24"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600">
            {t.exams.eyebrow}
          </span>
          <h2
            data-testid="exams-title"
            className="mt-3 text-3xl sm:text-4xl lg:text-[42px] font-extrabold tracking-tight text-blue-950 leading-[1.05]"
          >
            {t.exams.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            {t.exams.subtitle}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {t.exams.items.map((exam, i) => {
            const Icon = ICONS[i];
            const isNew = exam.tag === "New" || exam.tag === "புதியது";
            return (
              <div
                key={exam.name}
                data-testid={`exam-card-${i}`}
                className="card-lift relative bg-white border border-blue-900/10 rounded-2xl p-5 sm:p-6"
              >
                {isNew && (
                  <span className="absolute -top-2.5 right-4 inline-flex items-center gap-1 text-[10px] font-black tracking-[0.15em] uppercase text-slate-900 bg-amber-400 px-2.5 py-1 rounded-full shadow-md">
                    ★ {exam.tag}
                  </span>
                )}
                <div
                  className={`h-12 w-12 rounded-xl bg-gradient-to-br ${ACCENTS[i]} flex items-center justify-center`}
                >
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <p className="mt-4 text-base sm:text-lg font-bold text-blue-950 leading-tight">
                  {exam.name}
                </p>
                {!isNew && (
                  <p className="mt-1 text-[11px] font-semibold tracking-wider uppercase text-emerald-700">
                    ✓ {exam.tag}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Exams;
